import React, { useState } from "react"
import Lightbox from "yet-another-react-lightbox"
import "yet-another-react-lightbox/styles.css"
import { WorkshopListImagesType } from "../../types/mainModulTypes"
import { API } from "../../constants/constants"
import BaseSubheadline from "../common/BaseSubheadline"
import BaseRichtext from "../common/BaseRichtext"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Pagination } from "swiper/modules"
import "swiper/css"
import "swiper/css/pagination"

export default function WorkshopListImages(props: WorkshopListImagesType) {
    const [index, setIndex] = useState(-1)

    const slides = []

    if (props.workshopListImagesImageBig) {
        slides.push({
            src: API + props.workshopListImagesImageBig.url,
            alt: props.workshopListImagesImageBig.description ?? props.workshopListImagesImageBig.name,
        })
    }

    if (props.workshopListImagesBlockGallery) {
        props.workshopListImagesBlockGallery.forEach((image) => {
            slides.push({
                src: API + image.workshopListImagesBlockGalleryItemImage.url,
                alt: image.workshopListImagesBlockGalleryItemImage.description ?? image.workshopListImagesBlockGalleryItemImage.name,
            })
        })
    }

    return (
        <>
            <div className="max-w-content mx-auto px-4 lg:px-0">
                <Swiper
                    modules={[Navigation, Pagination]}
                    slidesPerView={1}
                    spaceBetween={50}
                    className="mySwiper  rounded-default block md:!hidden mb-2"
                    pagination>
                    {slides.map((slide, index) => (
                        <SwiperSlide key={index}>
                            <img src={slide.src} alt={slide.alt} className="aspect-[4/3] w-full object-cover" />
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className="flex gap-8 sm:items-center md:items-start pb-16">
                    <div className="px-1 md:px-0 flex-grow">
                        <BaseSubheadline label={props.workshopListImagesHeading} />
                        <BaseRichtext content={props.workshopListImagesText} classProps="py-2" />
                    </div>
                    <img
                        src={API + props?.workshopListImagesImageBig?.url}
                        alt={props.workshopListImagesImageBig?.description ?? props.workshopListImagesImageBig?.name}
                        className="w-1/2 aspect-square object-cover rounded-default cursor-pointer hidden md:block"
                        onClick={() => setIndex(0)}
                    />
                </div>
                <div className="md:flex justify-between gap-8 hidden">
                    {props?.workshopListImagesBlockGallery?.map((image, index) => (
                        <img
                            key={index}
                            src={API + image?.workshopListImagesBlockGalleryItemImage.url}
                            alt={image.workshopListImagesBlockGalleryItemImage.description}
                            className="aspect-square rounded-default object-cover w-[calc(33%-1.33rem)] cursor-pointer"
                            onClick={() => setIndex(index + 1)}
                        />
                    ))}
                </div>
            </div>

            <Lightbox slides={slides} open={index >= 0} index={index} close={() => setIndex(-1)} />
        </>
    )
}
